import {
  FETCH_GALLERY,
  FETCH_MOMENTS
} from 'app/actions/types';

import produce from 'immer';

const initialState = {
  gallery: null,
  moments: {
    byId: {},
    allIds: []
  }
}

const fetchResource = (resource, payload, draft) => {
  if (Array.isArray(payload)) {
    draft[resource].allIds = draft[resource].allIds.concat(payload.map(record => {
      draft[resource].byId[record.id] = record;
      return record.id;
    }));
  } else {
    draft[resource].byId[payload.id] = payload;
    draft[resource].allIds.push(payload.id);
  }
}

export default function(state = initialState, action) {
  switch(action.type) {
    case FETCH_GALLERY:
      return produce(state, draft => {
        draft.gallery = action.payload;
      });

    case FETCH_MOMENTS:
      return produce(state, draft => {
        fetchResource('moments', action.payload, draft);
      });

    default:
      return state;
  }
}
